module.exports = __webpack_public_path__ + "media/images/trust-icon-detection-db92e0d3012abdd8ea2feaff677addd2.svg";